/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  z as zod
} from 'zod'

/**
 * Creates a Fee Offsettable Expense
 */
export const feeOffsettableExpenseCreateParams = zod.object({
  "fundFamilyId": zod.string()
})

export const feeOffsettableExpenseCreateBody = zod.object({
  "transaction_code_config_id": zod.string().min(1),"amount": zod.string().min(1),"notes": zod.string().optional(),"fund_entities_affected_ids": zod.array(zod.string().min(1)),"id": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional(),"fund_family_event_id": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional()
})

/**
 * Deletes a Fee Offsettable Expense
 */
export const feeOffsettableExpenseDestroyParams = zod.object({
  "fundFamilyId": zod.string(),"id": zod.string()
})

